module.exports = __webpack_public_path__ + "img/si.a98f5ad.svg";